import React from 'react';
import { Popup } from 'devextreme-react/popup';
import { useDispatch, useSelector } from 'react-redux'
import { closeThisDialog, openThisDialog } from '../../store/dialog/dialogReducer';
import CustomButton from '../buttons/CustomButton';

const CustomPopup = ({id, title, icon, children}) => {

    const { open } = useSelector(store => store.dialog);
    const dispatch = useDispatch();

    const onHiding = (params) => dispatch(closeThisDialog());
    
    return (
        <div>
            <CustomButton
                text={`${title}`}
                type="default"
                icon={icon}
                onClick={() => dispatch(openThisDialog({id : id}))}
            />
            <Popup
                fullScreen={false}
                width={500}
                height={300}
                onHiding={onHiding}
                title={`${title}`}
                visible={open}
            >
                {children}
            </Popup>
        </div>
    );
}

CustomPopup.defaultProps = {
    icon: 'plus',
    id: 0
}

export default CustomPopup;
